import {
  formatterWithMinutes,
  formatterWithMinutesAndSeconds,
} from 'components/atoms/input-duration/formatter';
import { placeholderForEmpty } from 'components/atoms/table/formatters/empty-value-formatter';

export const formatTime = (minutes: number): string => {
  return minutes < 0
    ? `-${formatterWithMinutes(Math.abs(minutes))}`
    : formatterWithMinutes(minutes);
};

export const formatTimeWithSeconds = (minutes: number): string => {
  return minutes < 0
    ? `-${formatterWithMinutesAndSeconds(Math.abs(minutes))}`
    : formatterWithMinutesAndSeconds(minutes);
};

export const FormatTime = ({ value, showHypenIfZero = true }) => {
  return (
    <>
      {showHypenIfZero && (value === 0 || value == null)
        ? placeholderForEmpty
        : formatTime(value)}
    </>
  );
};

export const FormatTimeWithSeconds = ({ value, showHypenIfZero = true }) => {
  return (
    <>
      {showHypenIfZero && (value === 0 || value == null)
        ? placeholderForEmpty
        : formatTimeWithSeconds(value)}
    </>
  );
};
